import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {saveTexture} from "../../services/textureService";
import Button from "../Button";
import Toggle from "../Toggle";
import {withTranslation} from "react-i18next";
import {MdOutlineDataSaverOff} from "react-icons/md";
import {toast} from "react-toastify";

const FormTexture = ({t, data, id}) => {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        color: "#000000",
        imageId: null,
    });
    const [image, setImage] = useState({
        preview:
            "https://e7.pngegg.com/pngimages/641/399/png-clipart-upload-directory-document-document-file-up-upload-icon-miscellaneous-angle.png",
        data: null,
    });
    const [enabled, setEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {token} = useSelector((state) => state.user);

    const handleFileChange = (e) => {
        setImage({
            preview: URL.createObjectURL(e.target.files[0]),
            data: e.target.files[0],
        });
    };

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        setIsLoading(true);
        const response = await saveTexture(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/texture`,
            token,
            {
                id: id ? id : null,
                name: evt.target.name.value,
                color: evt.target.color.value,
                priority: evt.target.priority.value,
                isDouble: enabled,
                imageId: form.imageId ? form.imageId : null,
            },
            image.data
        );
        if (response.success) {
            setIsLoading(false);
            navigate("/textures");
            toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (data.length > 0) {
            setImage({
                preview: data[0].imageId
                    ? `${process.env.REACT_APP_HOST_BASE_URL}/v1/file/texture/${data[0].imageId}`
                    : "https://e7.pngegg.com/pngimages/641/399/png-clipart-upload-directory-document-document-file-up-upload-icon-miscellaneous-angle.png",
                data: "",
            });
            setForm({
                name: data[0].name,
                color: data[0].color,
                priority: data[0].priority,
                imageId: data[0].imageId,
            });
            setEnabled(data[0].isDouble);
        } else {
            return;
        }
    }, [data]);

    return (
        <>
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <h1 className="mb-5 text-xl font-semibold text-gray-900">
                    {data.length > 0 ? `${t(`update_textures`)}` : `${t(`add_textures`)}`}
                </h1>
                <form onSubmit={handleSubmit}>
                    <div className="overflow-hidden shadow sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                            <div className="grid grid-cols-6 gap-6 flex justify-between items-end">
                                <div className="col-span-6 sm:col-span-2 w-full">
                                    <label
                                        htmlFor="file-upload"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`laminate`)}
                                    </label>
                                    <div
                                        className="flex justify-center max-w-lg px-6 pt-5 pb-6 ml-auto border-2 border-gray-300 border-dashed rounded-md">
                                        <div className="space-y-1 text-center">
                                            <div className="flex justify-center mb-2">
                                                <img
                                                    src={image.preview}
                                                    className="rounded-lg"
                                                    width="112px"
                                                    height="64px"
                                                    alt="texturesimage"
                                                />
                                            </div>
                                            <div className="flex text-sm text-gray-600">
                                                <label
                                                    htmlFor="file-upload"
                                                    className="relative font-medium text-indigo-600 bg-white rounded-md cursor-pointer hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                                                >
                                                    <span>{t(`upload_file`)}</span>
                                                    {form.imageId === null ? (
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"
                                                            className="sr-only"
                                                            onChange={handleFileChange}
                                                        />
                                                    ) : (
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"
                                                            className="sr-only"
                                                            onChange={handleFileChange}
                                                        />
                                                    )}
                                                </label>
                                                <p className="pl-1">{t(`upload_file_text1`)}</p>
                                            </div>
                                            <p className="text-xs text-gray-500">
                                                {t(`upload_file_text2`)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-span-6 sm:col-span-2 p flex items-center">
                                    <Toggle enabled={enabled} setEnabled={setEnabled}/>
                                    <label
                                        className="block text-sm font-medium text-gray-700 pl-10"
                                    >
                                        {t(`both`)}
                                    </label>
                                </div>
                            </div>

                            <div className="grid grid-cols-6 gap-6 mt-8">
                                <div className="col-span-6 sm:col-span-2">
                                    <label
                                        htmlFor="name"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`name`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        required
                                        defaultValue={form.name}
                                        autoComplete="given-name"
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-1">
                                    <label
                                        htmlFor="color"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`color`)}
                                    </label>
                                    <input
                                        type="color"
                                        name="color"
                                        id="color"
                                        required
                                        defaultValue={form.color}
                                        autoComplete="family-name"
                                        className="w-full h-10 mt-1 border-none rounded-md"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-1">
                                    <label
                                        htmlFor="color"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`priority`)}
                                    </label>
                                    <input
                                        type="number"
                                        name="priority"
                                        id="priority"
                                        required
                                        defaultValue={form.priority}
                                        autoComplete="family-name"
                                        className="w-full h-10 mt-1 border-gray-300 rounded-md"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end px-4 py-3 text-right bg-gray-50 sm:px-6">
                            <Button type="button" to="/textures" btnName={t(`backward`)}/>

                            <button
                                type="submit"
                                className="text-white bg-blue-700 hover:bg-blue-800  font-medium rounded-lg text-sm px-5 py-1.5 text-center  dark:bg-blue-600 dark:hover:bg-blue-700  inline-flex items-center"
                            >
                                {t(`save`)}
                                {isLoading ? (
                                    <svg
                                        role="status"
                                        className="inline w-4 h-4 ml-1 text-white animate-spin"
                                        viewBox="0 0 100 101"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="#E5E7EB"
                                        />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                ) : (
                                    <MdOutlineDataSaverOff className="w-4 h-4 ml-1"/>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default withTranslation()(FormTexture);
